import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';
import { NotificationService } from '@core/services/notification.service';
import { SKIP_GLOBAL_ERROR } from '@core/http/skip-global-error';

let isRetrying = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const notification = inject(NotificationService);
  const skipGlobal = req.context.get(SKIP_GLOBAL_ERROR);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && req.url.includes('/api/') && !isRetrying) {
        isRetrying = true;
        return from(authService.getValidToken()).pipe(
          switchMap(token => {
            isRetrying = false;
            if (token) {
              const retryReq = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
              });
              return next(retryReq);
            }
            authService.login().subscribe();
            return throwError(() => error);
          }),
          catchError(retryError => {
            isRetrying = false;
            console.error('Unauthorized request after token refresh:', retryError);
            return throwError(() => retryError);
          })
        );
      }

      if (!skipGlobal) {
        if (error.status === 403) {
          notification.warning("Vous n'avez pas les droits nécessaires pour cette action.");
        } else if (error.status === 0) {
          console.error('Network error - backend may be offline or SSL cert rejected');
          notification.error('Connexion au serveur impossible. Vérifiez votre réseau.');
        } else if (error.status >= 500) {
          notification.error('Une erreur serveur est survenue. Réessayez plus tard.');
        }
      }

      return throwError(() => error);
    })
  );
};
